// extracted by mini-css-extract-plugin
module.exports = {"custom-table--header":"styles_custom-table--header__18byj"};